import styled from 'styled-components';
import React from 'react';
import { constants } from '../../constants';


const OuterContainer = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column nowrap;
    padding-bottom: 20px;
    margin-right: 20px;
`

const Label = styled.div`
    display: flex;
    flex: 1;
    flex-flow: row nowrap;
    font-size: ${constants.text.baseFontStyles.fontSize - 2}px;
    color: rgba(0, 0, 0, 0.4);
`

const Input = styled.input`
	box-shadow: none;
	padding: 9px;
	border-radius: 3px;
    /* margin: auto auto; */
`
const Checkbox = ({ input, labelText, style, children }) => (
    <OuterContainer style={style}>
        <Label>
            <div style={{ 
                width: 20, 
                height: 20, 
                marginRight: 15, 
                display: 'flex', 
                placeContent: 'center'
            }}>
                <Input 
                    {...input} 
                    type="checkbox" 
                    value="checked" 
                />
            </div>
            { labelText || children }
        </Label>
    </OuterContainer>
)

export default Checkbox;


// WEBPACK FOOTER //
// ./src/js/components/Form/Checkbox.jsx